import { app } from '@/main.js'
export const namespaced = true

export const state = {
  currentLocale: sessionStorage.getItem('selected_language')
}

export const mutations = {
  SET_LOCALE: function(state, value) {
    app.$i18n.locale = value
    state.currentLocale = value
    sessionStorage.setItem('selected_language', value)
  },
  INITIALIZE_LOCALE: function(state) {
    state.currentLocale = 'en'
    sessionStorage.setItem('selected_language', 'en')
  }
}

export const actions = {
  saveLocale({ commit }, value) {
    commit('SET_LOCALE', value)
  },
  initializeLocale({ commit }) {
    if (state.currentLocale == null) commit('INITIALIZE_LOCALE')
  }
}

export const getters = {
  GetCurrentLocale: state => {
    return state.currentLocale
  }
}
